const KEY = "nrc_recently_viewed";

export const getRecentSlugs = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

export const pushRecent = (slug) => {
  try {
    const list = [slug, ...getRecentSlugs().filter((s) => s !== slug)].slice(0, 12);
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    // private mode / storage disabled — feature silently off
  }
};
